import Vue from 'vue'

import pagination400 from "./pagination/Pagination-400"
import A from "./Tags/A"
import UpdateSiteMessage1 from "./UpdateSiteMessage/UpdateSiteMessage1"
import Loading3 from "./Loading/Loading3"
import CreateCommentModal1 from  "./Comments/CreateComment/Modal/CreateCommentModal1"

Vue.component('m-pagination-400', pagination400)

Vue.component('m-a', A)

Vue.component('m-update-site-message-1', UpdateSiteMessage1)

Vue.component('m-comment-create-modal-1', CreateCommentModal1)

Vue.component('m-loading-3', Loading3)
